export const STEP_LABELS = ['Хэл', 'Ерөнхий', 'Зураг', 'Гарчиг', 'Тайлбар', 'Хуудсууд'] as const;

export const BOOK_IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp';

/** Required pixel size for cover and promo images (width × height). */
export const BOOK_COVER_PROMO_IMAGE_WIDTH_PX = 1200;
export const BOOK_COVER_PROMO_IMAGE_HEIGHT_PX = 1520;

/** Required pixel size for each book page image (width × height, landscape). */
export const BOOK_PAGE_IMAGE_WIDTH_PX = 1920;
export const BOOK_PAGE_IMAGE_HEIGHT_PX = 1080;

/** Page image preview: `object-fit: contain`, aspect ratio preserved; `width: auto` avoids upscaling small files. */
export const BOOK_PAGE_IMAGE_PREVIEW_SX = {
  width: 'auto',
  maxWidth: '100%',
  height: 'auto',
  maxHeight: 'min(85dvh, calc(100dvw - 32px))',
  objectFit: 'contain' as const,
  display: 'block',
};

export const STEP_COUNT = STEP_LABELS.length;
